export default __webpack_public_path__ + "static/media/5s.54a51284.svg";